var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section order-section overflow-hidden",attrs:{"id":"order-section"}},[_c('OrderModelX'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }